import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { ActiveIcon } from "../../ui/icons/activeIcon";
import { EditIcon } from "../../ui/icons/edit";
import { InactiveIcon } from "../../ui/icons/inactiveIcon";
import { formatterDate } from "../../utils";
import { GetByIdAnagraphic, addPersonalManagementInstance, resetGetByIdStatus, resetPersonalManagementInstance } from "./boxAnagrafica/slice";
import { GetAllPersonalManagement, resetGetAllPersonalManagementResourcesStatus, setCurrentPersonalManagementId } from "./slice";

export function ListingPersonale() {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const personalManagement = useAppSelector(state => state.personalManagement)
    const anagraficaState = useAppSelector(state => state.PMAnagrafica)

    useEffect(() => {
        dispatch(GetAllPersonalManagement(personalManagement.filters))

    }, [])

    useEffect(() => {
        if (personalManagement.getAllPersonalManagementResourcesStatus === 'successfully') {
            dispatch(resetGetAllPersonalManagementResourcesStatus())
            dispatch(resetPersonalManagementInstance())
            if (personalManagement.getAllPersonalManagementResourcesResponse) {
                for (let index = 0; index < personalManagement.getAllPersonalManagementResourcesResponse.data.length; index++) {
                    if (personalManagement.getAllPersonalManagementResourcesResponse.data[index].anagraphicId) {
                        const idAnagraphic = personalManagement.getAllPersonalManagementResourcesResponse.data[index].anagraphicId
                        if (idAnagraphic) {
                            dispatch(GetByIdAnagraphic(idAnagraphic.toString()))
                        }
                    }

                }
            }
        }
    }, [personalManagement.getAllPersonalManagementResourcesStatus])

    useEffect(() => {
        if (anagraficaState.GetByIdAnagraphicStatus === 'successfully') {
            dispatch(resetGetByIdStatus('idle'))
            dispatch(addPersonalManagementInstance(anagraficaState.getByIdAnagraphicRequest))
        }
    }, [anagraficaState.GetByIdAnagraphicStatus])

    return (
        <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
            <table className="w-full border-collapse text-text-md">
                <thead>
                    <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">#</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Inizio</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Fine</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cognome</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Nome</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cod. Id.</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Regione</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Prov.</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Comune</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Recapito</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Stato</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[60px]"></th>
                    </tr>
                </thead>
                <tbody>
                    {anagraficaState.getByIdPMinstance.length === 0 ? (
                        <tr>
                            <td colSpan={12} className="px-3 py-3 text-left text-neutral-500 bg-white">
                                Nessun personale trovato
                            </td>
                        </tr>
                    ) : (
                        anagraficaState.getByIdPMinstance.map((user, index) =>
                            <tr
                                className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                key={user.id}
                            >
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{user.numScheda || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(user.starting)}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(user.ending)}</td>
                                <td className="px-3 py-2 text-blue-800 font-semibold whitespace-nowrap">{user.surname || '-'}</td>
                                <td className="px-3 py-2 text-blue-800 font-semibold whitespace-nowrap">{user.name || '-'}</td>
                                <td className="px-3 py-2 text-blue-800 font-semibold whitespace-nowrap">{user.identifierCode || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{user.region || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{user.province || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{user.city || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{user.firstPhone || '-'}</td>
                                <td className="px-3 py-2 text-center">
                                    {user.active ? <ActiveIcon /> : <InactiveIcon />}
                                </td>

                                <td className="px-3 py-2 w-[60px]">
                                    <div className="flex items-center justify-center gap-2">
                                        <button
                                            className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                            onClick={() => {
                                                dispatch(setCurrentPersonalManagementId(user.personalManagementId))
                                                navigate('/editPm/' + user.personalManagementId)
                                            }}
                                        >
                                            <EditIcon color={"Orange"} size={20} />
                                            <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                Modifica Personale
                                            </span>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    )
}